<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item active>Configuraciones</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div>
        <b-card no-body>
          <b-tabs content-class="mt-3" fill>
            <b-tab title="Catálogo de gastos" active>
              <CatGastos :loading="loading" />
            </b-tab>
            <b-tab title="Layouts de emails">
              <!-- <LayoutsDeEmails :layout="layout" :layouts="layouts" @getLayout="getLayout($event, layout.id)"
                @deleteFile="deleteFile($event, layout.id)" @saveLayout="saveLayout($event, layout.id)" /> -->
              <LayoutsDeEmails :layouts="layouts" @saveLayout="saveLayoutGo" />
            </b-tab>
            <b-tab title="Cupones">
              <Cupones />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutsDeEmails from "src/views/staff/settings/LayoutsDeEmails.vue";
import CatGastos from "src/views/staff/settings/CatGastos.vue";
import Cupones from "src/views/staff/settings/Cupones.vue";

import { LayoutsApi, FuncionesApi } from "@/api";

export default {
  name: "Settings",

  data: () => ({
    loading: false,

    layout: {
      body: null,
      file: null,
      header: null,
      // footer: null,
      subject: null,
      id: null
    },

    layouts: []
  }),

  watch: {
    "layout.file": "addFile"
  },

  components: {
    LayoutsDeEmails,
    CatGastos,
    Cupones
  },

  created() {
    this.loading = true;

    this.getLayouts()
      // .then(() => this.getContent())
      .catch(console.log)
      .finally(() => this.loading = false);

    // this.getContent();
  },

  methods: {
    async getLayouts() {
      const {value} = await LayoutsApi.list({
        page: 0,
        registersPerPage: 0
      });

      this.layouts = value;
    },

    async getContent() {
      try {
        this.loading = true;

        const { id, header, body, footer, subject } = await LayoutsApi.detail(1);

        this.layout.header = header;
        this.layout.body = body;
        this.layout.footer = footer;
        this.layout.subject = subject;
        this.layout.id = id;

      } catch {
      } finally {
        this.loading = false;
      }
    },

    async getLayout(id) {
      try {
        this.loading = true;

        const { header, body, footer, subject } = await LayoutsApi.detail(id);

        this.layout.header = header;
        this.layout.body = body;
        this.layout.footer = footer;
        this.layout.subject = subject;
        this.layout.id = id;
      } catch {
      } finally {
        this.loading = false;
      }
    },

    async addFile() {
      try {
        this.loading = true;

        const formData = new FormData();
        formData.append("file", this.layout.file);
        const value = await FuncionesApi.file(this.layout.id, "layouts", formData, {});
        this.layout.header = value;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    async deleteFile(id) {
      try {
        this.loading = true;

        const data = {
          url: this.layout.header,
          id: this.layout.id
        };

        await FuncionesApi.deleteFile("layouts", data, {});

        // this.layout.header = null;
        // this.layout.file = null;
        this.layout.header = null;
        this.layout.file = null;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    async containsUrlLoginStr() {
      const contains = '<a data-fr-linked="true" href="{urlLogin}">{urlLogin}</a>'; //"{urlLogin}";
      const result = this.layout.body.includes(contains);

      return result;
    },

    async containsPasswordStr() {
      const contains = "{password}";
      const result = this.layout.body.includes(contains);

      return result;
    },

    async containsAdminNameStr() {
      const contains = "{adminName}";
      const  result = this.layout.body.includes(contains);

      return result;
    },

    async containsUrlVerificacionStr() {
      const contains = '<a href="{urlVerificacion}">{urlVerificacion}</a>';
      const result = this.layout.body.includes(contains);

      return result;
    },

    async containsUrlRecuperacionStr() {
      const contains = '<a href="{urlRecuperacion}" style="user-select: auto;">{urlRecuperacion}</a>';
      const result = this.layout.body.includes(contains);

      return result;
    },

    async saveLayout() { // Not used rn
      this.loading = true;
      if (this.layout.id === 1) {
        var containsUrl = await this.containsUrlLoginStr();
        if (!containsUrl) {
          this.$toast.error("El cuerpo debe contener: {urlLogin}", {
            timeout: 6000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true
          });
          this.loading = false;
          return;
        }

        var containsPass = await this.containsPasswordStr();
        if (!containsPass) {
          this.$toast.error("El cuerpo debe contener: {password}", {
            timeout: 6000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true
          });
          this.loading = false;
          return;
        }
        this.saveLayoutGo();
      } else if (this.layout.id === 3) {
        var containsAdminNa = await this.containsAdminNameStr();
        if (!containsAdminNa) {
          this.$toast.error("El cuerpo debe contener: {adminName}", {
            timeout: 6000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true
          });
          this.loading = false;
          return;
        }
        var containsUrl = await this.containsUrlLoginStr();
        if (!containsUrl) {
          this.$toast.error("El cuerpo debe contener: {urlLogin}", {
            timeout: 6000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true
          });
          this.loading = false;
          return;
        }
        var containsPass = await this.containsPasswordStr();
        if (!containsPass) {
          this.$toast.error("El cuerpo debe contener: {password}", {
            timeout: 6000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true
          });
          this.loading = false;
          return;
        }
        this.saveLayoutGo();
      } else if (this.layout.id === 4) {
        var containsVerif = await this.containsUrlVerificacionStr();
        if (!containsVerif) {
          this.$toast.error("El cuerpo debe contener: {urlVerificacion}", {
            timeout: 6000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true
          });
          this.loading = false;
          return;
        }
        this.saveLayoutGo();
      } else if (this.layout.id === 5) {
        var containsRecu = await this.containsUrlRecuperacionStr();
        if (!containsRecu) {
          this.$toast.error("El cuerpo debe contener: {urlRecuperacion}", {
            timeout: 6000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true
          });
          this.loading = false;
          return;
        }
        this.saveLayoutGo();
      } else {
        this.saveLayoutGo();
      }
    },

    async saveLayoutGo(layout) {
      try {
        this.loading = true;

        const data = {
          tipo: layout.id,
          header: layout.header,
          body: layout.body,
          footer: layout.footer,
          subject: layout.subject,
          activo: 1
        };

        await LayoutsApi.edit(layout.id, data);

        this.$toast.success("Plantilla actualizada", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true
        });
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
